// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { CheckCircleOutline } from '@mui/icons-material';

// TODO: Import context
import { Context, } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import { ContentTitle, } from '../../Common/TypographyTYH';
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../../Common/BoxGridColumns';
import StackImage from '../../Common/StackImage';
import BoxImage from '../../Common/BoxImage';
import ListText from '../../Common/ListText';

const BoxEducationInfo = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BoxEducationInfo Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const items = [
        { text: '《職業字典》、《職業字典》-機場篇', thumbname: 'Tools_職業字典-機場篇' },
        { text: 'Holland職業性向測試卡', thumbname: 'Tools_Holland職業性向測試卡' },
        { text: '各款生涯規劃卡', thumbname: 'Tools_生涯規劃卡' },
        { text: '「生涯指紋」桌遊／遊戲卡', thumbname: 'Tools_生涯指紋' },
        { text: '「成功在夢」版圖遊戲', thumbname: 'Tools_成功在夢', description: ['認識自我：能力、強項', '訂定目標及管理人生'] },
        { text: '築夢工程', thumbname: 'Tools_築夢工程', description: ['啟發參與', '探索多元出路', '訂定目標及管理人生'] },
        { text: '我愛發薪日', thumbname: 'Tools_我愛發薪日', description: ['	能力訓練：應變取捨力、組織規劃力、金錢管理', '認識職場：投資、交易、拍賣等金融行業'] },
        { text: '糟了個糕！', thumbname: 'Tools_糟了個糕', description: ['認識自我', '訂定目標及管理人生'] },
        { text: '非凡的設計工作室', thumbname: 'Tools_非凡設計工作室', description: ['能力訓練：應變力、組織規劃力、匯報能力、觀察力、創意', '啟發參與'] },
        { text: 'CV人生規劃', thumbname: 'Tools_人生規劃', description: ['能力訓練：應變力、組織規劃力、匯報能力、觀察力、創意', '訂定目標及管理人生'] },
        { text: 'Profiler 眾裏尋他', thumbname: 'Tools_Profiler眾裏尋他', description: ['能力訓練：想像力、匯報能力、觀察力、創意、推理能力', '認識不同著名人物、歷史、推測其個人特質'] },
        { text: '勝在有腦', thumbname: 'Tools_勝在有腦', description: ['能力訓練：記憶力、邏輯、手眼協調等能力'] },
        { text: '大腦益智盒', thumbname: 'Tools_大腦益智盒', description: ['能力訓練：記憶力、觀察力', '探索多元出路'] },
        { text: '大想頭', thumbname: 'Tools_大想頭', description: ['能力訓練：想像力、匯報能力、觀察力、創意', '啟發參與'] },
        { text: '電流之戰', thumbname: 'Tools_電流之戰', description: ['能力訓練：應變力、組織規劃力', '了解電力產業'] },
    ];

    // TODO: Define event
    React.useEffect(() => { window.scrollTo(0, 0); }, []);

    // TODO: Return component
    return (
        <BoxGridColumnsContainer>
            <BoxGridColumnsFullWidth>
                <ContentTitle text={Text.StudentDevelopment.LifePlanning.Tools.Title[language]} />
                <Typography sx={{ color: 'info.main', textAlign: 'center' }} variant="body2">{Text.StudentDevelopment.LifePlanning.Tools.Description[language]}</Typography>
            </BoxGridColumnsFullWidth>
            {
                items.map(item =>
                    <StackImage key={item.thumbname}>
                        <BoxImage
                            src={`https://www.pohtyh.edu.hk/Files/StudentDevelopment/LifePlanning/${item.thumbname}.png`}
                            sx={{ objectFit: 'contain' }}
                        />
                        <Typography sx={{ alignItems: 'start', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                            {item.text}
                        </Typography>
                        {item.description && <ListText
                            customIcon={<CheckCircleOutline sx={{mr:1}} />}
                            lines={item.description}
                        />}
                    </StackImage>
                )
            }
        </BoxGridColumnsContainer>
    );
}

export default BoxEducationInfo;